<script setup lang="ts">
import IconChevron from '@/components/icons/IconChevron.vue'
import IconExternalLink from '@/components/icons/IconExternalLink.vue'
import type { RouteLocationRaw } from 'vue-router'

const props = defineProps<{
  isSelected?: boolean
  isExternal?: boolean
  to: RouteLocationRaw
}>()
</script>
<template>
  <a
    v-if="props.isExternal"
    :class="[
      $style.sidebarItem,
      props.isSelected ? $style['sidebarItem--active'] : null,
    ]"
    :href="props.to.toString()"
    target="_blank"
    rel="noopener noreferrer"
  >
    <slot />
    <IconExternalLink />
  </a>
  <RouterLink
    v-else
    :class="[
      $style.sidebarItem,
      props.isSelected ? $style['sidebarItem--active'] : null,
    ]"
    :to="props.to"
  >
    <slot />
    <IconChevron direction="right" />
  </RouterLink>
</template>
<style lang="scss" module>
.sidebarItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  color: $color-text-and-object-high-emphasis;

  &:hover {
    text-decoration: none;
  }

  &--active {
    background-color: $color-kollege-surface-2;
    color: $color-text-and-object-high-emphasis-inverse;
    font-weight: bold;
  }
}
</style>
